(function () {
  var DESKTOP_QUERY = window.matchMedia('(min-width: 992px)');

  function resizeCards(container) {
    var cardWrappers = container.querySelectorAll('[data-card-wrapper]');

    for (var i = 0; i < cardWrappers.length; i++) {
      cardWrappers[i].style.height = '';
    }

    if (!DESKTOP_QUERY.matches) {
      return;
    }

    var heights = [];

    for (var j = 0; j < cardWrappers.length; j++) {
      heights.push(cardWrappers[j].clientHeight);
    }

    if (heights.length === 0) {
      return;
    }

    var maxHeight = Math.max.apply(null, heights);

    if (maxHeight <= 0) {
      return;
    }

    for (var k = 0; k < cardWrappers.length; k++) {
      cardWrappers[k].style.height = maxHeight + 'px';
    }
  }

  function initSection(container) {
    resizeCards(container);

    window.addEventListener('resize', function () {
      resizeCards(container);
    });

    if (typeof DESKTOP_QUERY.addEventListener === 'function') {
      DESKTOP_QUERY.addEventListener('change', function () {
        resizeCards(container);
      });
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-component="science-mechanism"]');

    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
